/**
 * Design System
 * The kitchen sink of all design components
 */
import 'object_values';

import * as alert from 'atoms/alert';
import * as branding from 'atoms/branding';
import * as button from 'atoms/button';
import * as dropdown from 'atoms/dropdown';
import * as grid from 'atoms/grid';
import * as image from 'atoms/image';
import * as icon from 'atoms/icon';
import * as listGroup from 'atoms/list-group';
import * as text from 'atoms/text';
import * as nav from 'molecules/nav';
import * as card from 'molecules/card';
import * as carousel from 'molecules/carousel';
import * as collapsible from 'molecules/collapsible';
import * as jumbotron from 'molecules/jumbotron';
import * as pagination from 'molecules/pagination';
import * as accordion from 'organisms/accordion';
import * as article from 'organisms/article';
import * as contactForm from 'organisms/contact-form';
import * as footer from 'organisms/footer';
import * as navbar from 'organisms/navbar';
import * as highlightText from 'atoms/highlight-text';
import * as heading from 'atoms/heading';
import * as additionalText from 'molecules/additional_text';
import * as bannerText from 'molecules/banner_text';
import * as bannerPicture from 'molecules/banner_picture';
import * as doubleText from 'molecules/double_text';
import * as doubleColumnText from 'molecules/double_column_text';
import * as downloadList from 'molecules/download_list';
import * as expertCalc from 'molecules/expert_calc';
import * as folding from 'molecules/folding';
import * as headerbanner from 'molecules/headerbanner';
import * as separator from 'molecules/separator';
import * as slider from 'molecules/slider';
import * as faq from 'molecules/faq';
import * as smartCalc from 'molecules/smart_calc';
import * as textAndImage from 'molecules/text_and_image';
import * as textAndImageTeaser from 'molecules/text_and_image_teaser';
import * as textAndImageCutOut from 'molecules/text_and_image_cut_out';
import * as tripleCards from 'molecules/triple_cards';
import * as tripleColumn from 'molecules/triple_column';
import * as tripleColumnTeaser from 'molecules/triple_column_teaser';
import * as tripleIcon from 'molecules/triple_icon';
import * as formSection from 'molecules/form-section';
import * as inputRadio from 'atoms/input-radio';
import * as socialIcon from 'atoms/social-icon';
import * as page404 from 'organisms/page-404';
import * as header from 'molecules/header';
import * as aspectRatioBox from 'atoms/aspect-ratio-box';
import * as iframe from 'atoms/iframe';
import * as leasingOffers from 'organisms/leasing-offers';
import * as input from 'atoms/input';
import * as simpleSlider from 'molecules/simple-slider';
import * as leasingOfferGallery from 'molecules/leasing-offer-gallery';
import * as leasingOffer from 'organisms/leasing-offer';
import * as vehicleCalculatorResult from 'molecules/vehicle-calculator-result';
import * as vehicleCalculator from 'organisms/vehicle-calculator';
import * as hubspotButton from 'molecules/hubspot-button';
import * as modal from 'atoms/modal';
import * as searchInput from 'molecules/search-input';
import * as searchResult from 'molecules/search-result';

const components = {
  alert,
  branding,
  button,
  dropdown,
  grid,
  image,
  icon,
  listGroup,
  text,
  nav,
  card,
  carousel,
  collapsible,
  jumbotron,
  pagination,
  accordion,
  article,
  contactForm,
  footer,
  navbar,
  highlightText,
  heading,
  additionalText,
  bannerText,
  bannerPicture,
  doubleText,
  doubleColumnText,
  downloadList,
  expertCalc,
  folding,
  headerbanner,
  separator,
  slider,
  faq,
  smartCalc,
  textAndImage,
  textAndImageTeaser,
  textAndImageCutOut,
  tripleCards,
  tripleColumn,
  tripleColumnTeaser,
  tripleIcon,
  formSection,
  inputRadio,
  socialIcon,
  page404,
  header,
  aspectRatioBox,
  iframe,
  leasingOffers,
  input,
  simpleSlider,
  leasingOfferGallery,
  leasingOffer,
  vehicleCalculatorResult,
  vehicleCalculator,
  hubspotButton,
  modal,
  searchInput,
  searchResult,
};
/**
 * Default export of object containing all components
 */
export default components;

/**
 * All component names as an array
 * @returns {Array} List of components name strings
 */
export const componentNames = () =>
  Object.values(components).map(({ name }) => name);

/**
 * Enable all components against a piece of DOM with some settings
 */
export const enableAllComponents = ($dom, settings) =>
  Object.values(components).forEach(({ enable }) => {
    // continue, even if one component fails
    try {
      enable($dom, settings)
    } catch (e) {
      console.error(e)
    }
  });
